import { observable } from 'mobx';

export type TripApproveItemJson = {
  id: number;
  userDisplayName: string;
  dataType: string;
  value: string;
  valueCode?: string;
  fileType?: string;
  filePath?: string;
};

export type TripApproveItemResponseArgs = {
  id: number;
  trip_id: number;
  json?: string;
  parsed_approve_items?: Array<{
    id: number;
    name: string;
    value: string;
    file_type?: string;
    file_path?: string;
  }>;
};

export type TripApproveItemArgs = {
  id: number;
  tripId: number;
  json?: TripApproveItemJson[];
  parsedApproveItems?: Array<{
    id: number;
    name: string;
    value: string;
    fileType?: string;
    filePath?: string;
  }>;
};

export const convertTripApproveItemResponseToArgs = (
  response: TripApproveItemResponseArgs
): TripApproveItemArgs => {
  // JSONの解析（サーバーからは常に文字列）
  let jsonData: TripApproveItemJson[] | undefined;
  if (response.json) {
    try {
      jsonData = JSON.parse(response.json);
    } catch {
      jsonData = undefined;
    }
  }

  // parsed_approve_itemsの変換
  const parsedApproveItems = response.parsed_approve_items?.map(item => ({
    id: item.id,
    name: item.name,
    value: item.value,
    fileType: item.file_type,
    filePath: item.file_path
  }));

  return {
    id: response.id,
    tripId: response.trip_id,
    json: jsonData,
    parsedApproveItems
  };
};

export default class TripApproveItem {
  @observable id: number;
  @observable tripId: number;
  @observable json?: TripApproveItemJson[];
  @observable parsedApproveItems?: Array<{
    id: number;
    name: string;
    value: string;
    fileType?: string;
    filePath?: string;
  }>;

  constructor(args: TripApproveItemArgs) {
    this.id = args.id;
    this.tripId = args.tripId;
    this.json = args.json;
    this.parsedApproveItems = args.parsedApproveItems;
  }

  getParsedItems(): Array<{
    id: number;
    name: string;
    value: string;
    fileType?: string;
    filePath?: string;
  }> {
    if (this.parsedApproveItems) {
      return this.parsedApproveItems;
    }

    if (!this.json) {
      return [];
    }

    return this.json
      .filter(item => item.dataType !== 'label')
      .map(item => {
        const result: {
          id: number;
          name: string;
          value: string;
          fileType?: string;
          filePath?: string;
        } = {
          id: item.id,
          name: item.userDisplayName,
          value: item.valueCode ? `${item.valueCode}${item.value}` : item.value
        };

        if (item.dataType === 'file') {
          result.fileType = item.fileType;
          result.filePath = item.filePath;
        }

        return result;
      });
  }
}
